<template>
  <v-row v-if="teamMembersWithRunningTasks.length > 0" dense justify="center" class="mb-2">
    <v-col cols="auto">
      <v-chip-group>
        <v-chip
          v-for="teamMember in teamMembersWithRunningTasks"
          :key="teamMember.id"
          color="orange"
          outlined
          small
          @click="showTeamMemberTasks(teamMember)"
          class="mx-2"
        >
          <v-icon left small>mdi-account-clock</v-icon>
          {{ teamMember.name }}
        </v-chip>
      </v-chip-group>
    </v-col>
    
    <RunningTasksDialog
      v-model="showRunningTasksDialog"
      :running-tasks="filteredRunningTasksForSelectedMember"
      :show-short="showShort"
      v-on:short="$emit('short', $event)"
    />
  </v-row>
</template>

<script>
import RunningTasksDialog from "@/components/RunningTasksDialog.vue";

export default {
  name: 'TeamMemberTaskButtons',
  components: {RunningTasksDialog},
  props: {
    taskMap: {
      type: Object,
      default: () => ({})
    },
    showShort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedTeamMemberForTasks: null,
      showRunningTasksDialog: false
    }
  },
  computed: {
    teamMembersWithRunningTasks() {
      const tasks = Object.values(this.taskMap);
      const teamMembersMap = new Map();
      
      tasks.forEach(task => {
        const lastExecution = task.execution && task.execution[task.execution.length - 1];
        if (lastExecution && lastExecution.stop === null && lastExecution.team_members) {
          lastExecution.team_members.forEach(tm => {
            if (!teamMembersMap.has(tm.id)) {
              teamMembersMap.set(tm.id, tm);
            }
          });
        }
      });
      
      return Array.from(teamMembersMap.values()).sort((a, b) => a.name.localeCompare(b.name));
    },
    filteredRunningTasksForSelectedMember() {
      if (!this.selectedTeamMemberForTasks) {
        return [];
      }
      
      const tasks = Object.values(this.taskMap);
      const selectedMemberId = this.selectedTeamMemberForTasks.id;
      
      const isRunningTask = task => {
        const lastExecution = task.execution && task.execution[task.execution.length - 1];
        return lastExecution && lastExecution.stop === null;
      }
      
      const includesSelectedMember = task => {
        const lastExecution = task.execution && task.execution[task.execution.length - 1];
        if (!lastExecution || !lastExecution.team_members) {
          return false;
        }
        return lastExecution.team_members.some(tm => tm.id === selectedMemberId);
      }
      
      return tasks.filter(task => isRunningTask(task) && includesSelectedMember(task));
    }
  },
  watch: {
    showRunningTasksDialog(newVal) {
      if (!newVal) {
        this.selectedTeamMemberForTasks = null;
      }
    }
  },
  methods: {
    showTeamMemberTasks(teamMember) {
      this.selectedTeamMemberForTasks = teamMember;
      this.showRunningTasksDialog = true;
    }
  }
}
</script>